// extracted by mini-css-extract-plugin
module.exports = {"btns":"OrderLevel_btns__a7858","editBtn":"OrderLevel_editBtn__2tI6C","deleteBtn":"OrderLevel_deleteBtn__3BsMn"};